import { useState } from 'react';
import { Button, Card, CardSubtitle, CardTitle, Wordmark } from '@keobook/ui';
import { useAuth } from '../lib/auth';
import { api } from '../lib/api';

/**
 * Billing-lapse recovery screen. GuidedRoute routes a client here once its
 * subscription has ended — 'canceled' (period lapsed) or 'frozen' (suspended).
 * ('past_due' is not gated — Stripe is still retrying the card.) The app is
 * gated until they resolve billing; the primary action opens the Stripe billing
 * portal, which handles re-subscribing / updating the card.
 */
export function Reactivate() {
  const { signOut } = useAuth();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const title = 'Your subscription has ended';
  const body =
    'Your plan has lapsed and access is paused. Reactivate to pick up right where you left off — nothing has been deleted.';
  const cta = 'Reactivate subscription';

  async function onManageBilling() {
    setError(null);
    setBusy(true);
    try {
      const { url } = await api.openBillingPortal();
      window.location.assign(url);
    } catch (err: unknown) {
      setError(
        err instanceof Error
          ? err.message
          : 'Could not open the billing page. Please try again, or email hello@keobooks.com.',
      );
      setBusy(false);
    }
  }

  return (
    <main className="kb-auth-page">
      <div className="kb-auth-container" style={{ maxWidth: 480 }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <Wordmark size="lg" />
        </div>
        <Card size="xl">
          <CardTitle>{title}</CardTitle>
          <CardSubtitle>{body}</CardSubtitle>

          {error && (
            <div role="alert" className="kb-form-error" style={{ marginTop: '0.75rem' }}>
              {error}
            </div>
          )}

          <div style={{ marginTop: '1.25rem' }}>
            <Button block disabled={busy} onClick={onManageBilling}>
              {busy ? 'Opening…' : cta}
            </Button>
          </div>
          <div style={{ marginTop: '0.75rem' }}>
            <Button block variant="ghost" onClick={() => void signOut()}>
              Sign out
            </Button>
          </div>
          <p style={{ marginTop: '1rem', fontSize: 13, color: '#7a7870', textAlign: 'center' }}>
            Questions? Email{' '}
            <a href="mailto:hello@keobooks.com" style={{ color: 'var(--kb-green-600)' }}>
              hello@keobooks.com
            </a>
            .
          </p>
        </Card>
      </div>
    </main>
  );
}
